{
  "organizationsHeading": "Organisationen"
}
